export default __webpack_public_path__ + "static/media/terms-of-service-consent-en-2.5c2294f6.jpg";